import { useEffect, useRef, useState } from 'react'
import { downloadAnswer } from '../../services/exports'

const FORMATS = [
  { id: 'docx', label: 'Word (.docx)' },
  { id: 'pdf', label: 'PDF (.pdf)' },
  { id: 'txt', label: 'Text (.txt)' },
]

const IconDownload = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

// Download menu for one assistant answer: pick a format, stream the file. `scope`
// is 'searchroom' | 'global'; `chatId` is the owning room/chat id.
function MessageExport({ scope, chatId, messageId }) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState('')
  const [error, setError] = useState('')
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [open])

  const run = async (format) => {
    if (busy) return
    setBusy(format)
    setError('')
    try {
      await downloadAnswer({ scope, chatId, messageId, format })
      setOpen(false)
    } catch (err) {
      setError(err.message || 'Export failed')
    } finally {
      setBusy('')
    }
  }

  return (
    <div className="msg-export" ref={ref}>
      <button
        type="button"
        className="msg-export-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        title="Download this answer"
        onClick={() => setOpen((v) => !v)}
      >
        <IconDownload />
        <span>Download</span>
      </button>
      {open ? (
        <div className="msg-export-menu" role="menu">
          {FORMATS.map((f) => (
            <button
              key={f.id}
              type="button"
              role="menuitem"
              disabled={Boolean(busy)}
              onClick={() => run(f.id)}
            >
              {busy === f.id ? 'Preparing…' : f.label}
            </button>
          ))}
          {error ? <div className="msg-export-error">{error}</div> : null}
        </div>
      ) : null}
    </div>
  )
}

export default MessageExport
